import { Toaster } from '../ui/sonner';
import '../../styles/studio.css';

interface TemplateStudioLayoutProps {
  children: React.ReactNode;
}

export default function TemplateStudioLayout({ children }: TemplateStudioLayoutProps) {
  return (
    <div className="template-studio">
      {children}
      <Toaster position="bottom-right" />
    </div>
  );
}
